// extracted by mini-css-extract-plugin
export default {"container":"ZpN8ZYAx","card":"HtolbRV1","content":"mLZ4bKEt","titleRow":"JTJH2fb3","icon":"DtPHsYHI","title":"Bhw3A7fn","meta":"rYGkatfB","replyCount":"dS3rfQQG"};